import Logger from './Logger';
import SentryProvider from './provider/Sentry';
import ConsoleProvider from './provider/Console';

var createLogger = function createLogger() {
  var loggerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var logger = new Logger();

  if (process.env.NODE_ENV === 'production') {
    logger.addProvider(new SentryProvider(loggerName));
  } else {
    logger.addProvider(new ConsoleProvider());
  }

  return logger;
};

export default createLogger;